// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"AtCompanySidebar_sidebarContainer__3TNHE","sidebarCorpInfoTitle":"AtCompanySidebar_sidebarCorpInfoTitle__1osIU"};